module.exports = __webpack_public_path__ + "img/resource4.62a44e04.jpg";